<template>
    <div v-if="emailEnabled">
        <div class="dropdown show">
            <button href="#" class="btn btn-link btn-sm px-1 py-0 dropdown-toggle" role="button" id="forwardDropdownLink" data-toggle="dropdown" :title="text" :disabled="disabled">
                <i :class="['fas fa-lg', icon]"></i>                      
            </button>
            <div class="dropdown-menu font-small">
                <a class="dropdown-item my-0 py-0" href="javascript:void(0)" @click="onclick(TransmissionMethod.FAX)">
                    <i class="fas fa-fax text-primary submit-icon"></i> Fax
                </a>
                <div class="dropdown-divider my-1 py-0"></div>
                <a class="dropdown-item my-0 py-0" href="javascript:void(0)" @click="onclick(TransmissionMethod.EMAIL)">
                    <span class="fa-stack secure-email">
                        <i class="fas fa-envelope fa-stack-2x text-primary submit-icon"></i>
                        <i class="fas fa-lock fa-stack-1x lock"></i>                                                
                    </span>                                
                    <span class="secure-email-text">Secure Email</span>
                </a>
            </div>
        </div>                                                  
    </div>
    <div v-else>
        <button type="button" class="btn btn-link pl-1 py-0" :title="text" @click="onclick(TransmissionMethod.FAX)">
            <i :class="['fas fa-lg', icon]"></i>
        </button>
    </div>    
</template>

<script>
import { TransmissionMethod } from '../../constants.js';

export default {
    props: {
        icon: String,
        text: String,
        object: Object,        
        emailEnabled: Boolean,
        disabled: Boolean
    },
    data() {
        return {
            TransmissionMethod
        }
    },
    methods: {
        onclick: function (method) {
            this.$emit('click', method, this.object);
        }
    }
}
</script>

<style scoped>
    .font-small {
        font-size: .95em;
    }    

    .submit-icon {
        font-size: 1.2em;
    }

    .secure-email {
        position: relative;
        top: 4px;
        left: -5px;
    }

    .secure-email-text {
        position: relative;
        left: -9px;
    }

    .lock {
        position: relative;
        top: 3px;
        left: 7px;
        color: #bcbcbc;
        font-size: 0.75em;
    }
</style>